(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lance-inquiry"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-inquiry-open]').forEach(function(b){b.addEventListener('click',function(){var d=document.querySelector('[data-inquiry]');if(d)d.showModal();});});
document.querySelectorAll('[data-inquiry-close]').forEach(function(b){b.addEventListener('click',function(){b.closest('dialog').close();});});
  } catch(e) { console.error(e); }
})();

})();
